import {rootReducer} from './reducers/main';
import {configureStore} from '@reduxjs/toolkit';

export const store: any = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof store>;
export type AppDispatch = typeof store.dispatch;

declare module 'react-redux' {
  export interface DefaultRootState extends ReturnType<typeof rootReducer> {}
}
